<template>
  <div class="index">
    <Seacher @search="searchs"></Seacher>
    <div class="transactionsbox">
      <div class="transactionstit">Transaction Details</div>
      <div class="transactionsc">
        <div class="tit">Block Height :</div>
        <div
          class="conc cond"
          style="margin-top: 4px"
          @click="goDetail('height', height)"
        >
          {{ height }}
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Block Hash :</div>
        <div class="conc" style="margin-top: 4px">
          {{ blHash }}
        </div>
      </div>
      <div class="transactionsc" style="height: 86px">
        <div class="tit">Transaction Hash :</div>
        <div class="conc conca" style="margin-top: 4px">
          <div>{{ txHash }}</div>
          <img
            src="@/assets/pc/Index/fz.png"
            v-clipboard:copy="txHash"
            v-clipboard:success="copyClicked"
            v-clipboard:error="onError"
          />
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Time :</div>
        <div class="conc" style="margin-top: 4px">
          {{ tradeTime }}({{ timeas }})
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Gas :</div>
        <div class="conc" style="margin-top: 4px">{{ gas }} TTOS</div>
      </div>
      <!-- <div class="transactionsc transactionscd">
        <div class="tit" style="margin-bottom: 4px">Signed Nodes :</div>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            :title="signList.length + ' signers (See all)'"
            name="1"
          >
            <div class="block_boxlist">
              <div
                class="block_li"
                v-for="(item, index) in signList"
                :key="index"
                @click="goDetail('address', item)"
              >
                {{ item }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div> -->
    </div>

    <!-- 普通交易开始 -->
    <div
      class="transactionsbox"
      v-if="
        type == 1 ||
        type == 2 ||
        type == 3 ||
        type == 4 ||
        type == 5 ||
        type == 'to' ||
        type == 'from' ||
        type == -1
      "
    >
      <div class="transactionstit">Overview</div>
      <div class="transactionsc">
        <div class="tit">Transaction Type:</div>
        <div class="conc" style="margin-top: 6px">{{ typename }}</div>
      </div>
      <div class="transactionsc">
        <div class="tit">From :</div>
        <div
          class="conc cond"
          style="margin-top: 6px"
          v-if="typename !== 'Bonus'"
        >
          <span
            @click="goDetail('address', fromAddress)"
            v-if="fromAddress !== 'Unstake'"
            style="
              width: 200px;
              overflow: hidden;
              display: block;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
            "
            >{{ fromAddress }} </span
          ><img
            v-if="fromAddress !== 'Unstake'"
            style="width: 24px; height: 24px"
            v-clipboard:copy="fromAddress"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            src="@/assets/pc/Index/fz.png"
          />
          <span v-else style="color: #898b8d">{{ fromAddress }}</span>
        </div>
        <div class="conc" v-if="typename == 'Bonus'">
          <span>Bonus</span>
        </div>
      </div>
      <div
        class="transactionsc"
        v-if="
          toAddressa.length == 0 &&
          toAddressb != 'Stake' &&
          typename !== 'Genesis'
        "
      >
        <div class="tit">To :</div>
        <div class="conc" style="margin-top: 6px">
          <div
            class="block_toli"
            v-if="
              toAddressa.length == 0 &&
              toAddressb !== 'Pledge' &&
              toAddressb != 'Stake'
            "
          >
            <span @click="goDetail('address', toAddressb)">
              {{ toAddressb }}</span
            ><img
              v-clipboard:copy="toAddressb"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              src="@/assets/pc/Index/fz.png"
            />
          </div>
          <div class="block_toli" v-else>
            <span style="color: #898b8d"> Stake</span>
          </div>
        </div>
      </div>
      <div class="transactionsc" v-if="toAddressb == 'Stake'">
        <div class="tit">To :</div>
        <div class="conc" style="margin-top: 6px">Stake</div>
      </div>
      <div class="transactionsc" v-if="toAddressaa.length >= 5">
        <div class="tit">To :</div>
        <div class="conc" style="margin-top: 6px">
          <div
            class="block_toli"
            v-for="(item, index) in toAddressaa.slice(0, 5)"
            :key="index"
          >
            <span @click="goDetail('address', item.address)">{{
              item.address
            }}</span
            ><img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="item.address"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            />
            <span
              >{{
                new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                  maximumFractionDigits: 20,
                }).format(item.amount)
              }}TTOS</span
            >
          </div>
          <el-button
            type="text"
            @click="dialogVisible = true"
            v-if="toAddressaa.length >= 5"
          >
            <div class="btns">More</div>
          </el-button>
        </div>
      </div>
      <div
        class="transactionsc"
        v-if="toAddressaa.length < 5 && toAddressaa.length >= 1"
      >
        <div class="tit">To:</div>
        <div class="conc">
          <div
            class="block_toli"
            v-for="(item, index) in toAddressaa"
            :key="index"
          >
            <span v-if="toAddressb != 'Stake'">
              <span @click="goDetail('address', item.address)">{{
                item.address
              }}</span
              ><img
                v-clipboard:copy="item.address"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                src="@/assets/pc/Index/fz.png"
              />
            </span>
            <span v-else style="color: #898b8d">{{ toAddressb }} /></span>
            <img
              v-clipboard:copy="item.address"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              src="@/assets/pc/Index/fz.png"
            />
            <!-- <span>{{ item.amount }}TFSC</span> -->
          </div>
        </div>
      </div>
      <div class="transactionsc" v-if="typename != 'Genesis'">
        <div class="tit">Amount :</div>
        <div class="conc" style="margin-top: 6px">
          {{
            new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
              maximumFractionDigits: 20,
            }).format(amount)
          }}
          TTOS
        </div>
      </div>
      <!-- <div style="border: 1px solid red;width: 702px;height: 1307px;"> -->
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        :modal="true"
        :before-close="handleClose"
      >
        <div class="tangkuang">
          <div class="tit" @click="handleClose">
            <img src="@/assets/m/home/tan.png" />
          </div>
          <div class="tangkuang_tit">
            <div>Address</div>
            <div>Amount</div>
          </div>
          <div class="tangkuang_con">
            <div
              class="tangkuang_li"
              v-for="(item, index) in toAddressa"
              :key="index"
            >
              <span @click="goDetail('address', item.address)">{{
                item.address
              }}</span
              ><img
                src="@/assets/pc/Index/fz.png"
                v-clipboard:copy="item.address"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              /><span>
                {{
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 10,
                  }).format(item.amount)
                }}
                TTOS</span
              >
            </div>
          </div>
          <div class="Block_List_Bottom">
            <el-pagination
              ref="Pagination"
              :current-page.sync="pageNum"
              small
              background
              :page-size="5"
              :pager-count="5"
              layout="prev, pager,
      next"
              @current-change="handleCurrentChange"
              :total="total1"
            >
            </el-pagination>
          </div>
        </div>
      </el-dialog>
      <!-- </div> -->
    </div>

    <!-- 普通交易结束 -->

    <!-- 申领交易开始 -->
    <div
      class="transactionsbox"
      v-if="
        type == 99 ||
        type == 'toAward' ||
        type == 'commission' ||
        type == 'fromAward'
      "
    >
      <div class="transactionstit">Overview</div>
      <div class="transactionsc">
        <div class="tit">Validator :</div>
        <div class="conc conca conc1" style="margin-top: 6px">
          <img class="imgs" :src="validatorLogo" style="border-radius: 50%" />
          <div class="block_hash" @click="goDetail('address', address)">
            {{ validatorNickName }}
          </div>
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Bonus era :</div>
        <div class="conc conc1" style="margin-top: 6px">
          {{ TimeDatea }} 00:00:00-{{ TimeDatea }} 24:00:00
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Amount :</div>
        <div class="conc conc1" style="margin-top: 6px">
          {{
            new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
              maximumFractionDigits: 20,
            }).format(amount)
          }}
          TTOS
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Commission :</div>
        <div class="conc conc1" style="margin-top: 6px">
          {{
            new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
              maximumFractionDigits: 20,
            }).format(Commission)
          }}
          TTOS
        </div>
      </div>
      <div class="transactionsc">
        <div class="tit">Bonus :</div>
        <div
          class="conc conc1"
          v-for="(item, index) in toAwardList.slice(0, 5)"
          :key="index"
        >
          <div style="color: #fff" @click="goDetail('address', item.address)">
            {{ item.address }}
          </div>
          <div>
            {{ parseFloat(item.amount).toFixed(8) }}TTOS({{
              ((item.amount / percentages) * 100).toFixed(2)
            }}%)
          </div>
        </div>
        <div
          style="color: #fff; padding-bottom: 20px"
          v-if="toAwardList.length > 5"
          @click="dialogVisible3 = true"
        >
          More
        </div>
      </div>
      <el-dialog
        title=""
        :visible.sync="dialogVisible3"
        :modal="true"
        :before-close="handleClose"
      >
        <div class="tangkuang" style="overflow: hidden; overflow-y: auto">
          <div class="tit" @click="handleClose">
            <img src="@/assets/m/home/tan.png" />
          </div>
          <div class="tangkuang_tit">
            <div>Address</div>
            <div>Amount</div>
          </div>
          <div class="tangkuang_con">
            <div
              class="tangkuang_li"
              v-for="(item, index) in toAwardList"
              :key="index"
            >
              <span
                @click="goDetail('address', item.address)"
                style="
                  width: 160px;
                  margin-top: 10px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                >{{ item.address }}</span
              ><img
                src="@/assets/pc/Index/fz.png"
                v-clipboard:copy="item.address"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="margin-left: 0px"
              /><span style="width: 400px">
                {{ parseFloat(item.amount).toFixed(8) }} TTOS({{
                  ((item.amount / percentages) * 100).toFixed(2)
                }}%)</span
              >
            </div>
          </div>
          <!-- <div class="Block_List_Bottom">
            <el-pagination
              ref="Pagination"
              :current-page.sync="pageNum"
              small
              background
              :page-size="5"
              :pager-count="5"
              layout="prev, pager,
      next"
              @current-change="handleCurrentChange"
              :total="total1"
            >
            </el-pagination>
          </div> -->
        </div>
      </el-dialog>
    </div>

    <!-- 申领交易开始 -->
    <div class="content_top" id="list" v-if="type == 7">
      <div class="head">Overview</div>
      <div class="content_center centers">
        <div class="block_height">
          <div class="block_tit">Transaction Type :</div>
          <div class="block_con" style="margin-top: 6px; padding-bottom: 16px">
            Contract Creation
          </div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">Contract Creator :</div>
          <div class="block_con" style="margin-top: 6px">
            <div
              class="block_hash blockas"
              @click="goDetail('address', contractCreator)"
            >
              {{ contractCreator }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="contractCreator"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">Contract Address :</div>

          <div class="block_con" style="margin-top: 6px">
            <div
              class="block_hash blockas"
              v-if="standard == 'ERC-721'"
              @click="goDetail('nfthash', contractAddress)"
            >
              {{ contractAddress }}
            </div>
            <div
              class="block_hash blockas"
              v-if="standard == 'ERC-20'"
              @click="goDetail('hash', contractAddress)"
            >
              {{ contractAddress }}
            </div>
            <el-tooltip placement="right" popper-class="toolTipClass">
              <div slot="content">Smart contract account</div>
              <img
                src="../../assets/m/home/wdang.png"
                style="margin-left: 2px"
              />
            </el-tooltip>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="contractAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height" style="border-bottom: none">
          <div class="block_tit">Contract Name :</div>
          <div class="block_con">{{ contractName }}</div>
        </div>
        <!-- <div class="block_height" style="height: 138px">
          <div class="block_tit">Tokens Transferred :</div>
          <div class="block_con">
            <div
              class="block_hash blockas" style="display: flex;color: #fff !important;"
              @click="goDetail('address', fromAddress)"
            >
              <span>From</span> <span style="display: inline-block;width:100px; text-align: left;margin-left: 6px; overflow:hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          -o-text-overflow:ellipsis; color: #fff !important;">{{ fromAddress }}</span>
            </div>
            
            <img
              src="../../assets/m/copy@2x.png"
              v-clipboard:copy="fromAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="block_con" v-if="toAddress !== ''">
            <div
              class="block_hash blockas"
              @click="goDetail('address', toAddress)"
            >
              <span>To111</span> {{ toAddress }}
            </div>
            <img
              src="../../assets/m/copy@2x.png"
              v-clipboard:copy="toAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="block_con" v-else>
            <div
              class="block_hash blockas"
             
            >
              <span>To</span> ...
            </div>
            
          </div>


          <div class="block_con">
            <div class="block_hash" @click="goDetail('hash', contractAddress)">
              <span class="spanblack" style="color: #fff">{{
                tokenAmount
              }}</span
              ><img class="imgs" :src="logo" /><span class="spanblack">
                {{ symbol }}</span
              >
            </div>
          </div>
        </div>

        <div class="block_height borernone">
          <div class="block_tit">Amount :</div>
          <div class="block_con">
            <div class="block_hash">0 TFSC</div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- taken开始 -->
    <div class="content_top" id="list" v-if="type == 8 && standard == 'ERC-20'">
      <div class="head">Overview</div>
      <div class="content_center centers">
        <div class="block_height block_height1">
          <div class="block_tit">Transaction Type :</div>
          <div class="block_con" style="margin-top: 4px">{{ functions }}</div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">From :</div>
          <div class="block_con" style="margin-top: 4px">
            <div
              class="block_hash blockas"
              @click="goDetail('address', fromAddress)"
            >
              {{ fromAddress }}
            </div>
            <img
              src="../../assets/m/copy@2x.png"
              v-clipboard:copy="fromAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height" style="height: 100px">
          <div class="block_tit">Interacted WIth (To) :</div>
          <div class="block_con" style="margin-top: 6px">
            <div
              class="block_hash blockas"
              @click="goDetail('hash', contractAddress)"
            >
              Contract
            </div>
            <el-tooltip placement="right" popper-class="toolTipClass">
              <div slot="content">Smart contract account</div>
              <img src="../../assets/m/home/wdang.png" />
            </el-tooltip>
          </div>
          <div class="block_con">
            <div
              class="block_hash blockas"
              @click="goDetail('hash', contractAddress)"
            >
              {{ contractAddress }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="contractAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height" style="height: 108px">
          <div class="block_tit" style="margin-bottom: 8px">
            Tokens Transferred :
          </div>
          <div class="block_con">
            <div
              class="block_hash blockas"
              @click="goDetail('address', fromAddress)"
            >
              <span>From</span> {{ fromAddress1 }}
            </div>
            <!-- <img src="../../assets/m/home/wdang.png" /> -->
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="fromAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="block_con" v-if="toAddress == ''">
            <div
              class="block_hash blockas"
              @click="goDetail('address', toAddress)"
            >
              <span>To</span> {{ toAddress1 }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="toAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="block_con" v-if="toAddress1 !== ''">
            <div
              class="block_hash blockas"
              @click="goDetail('address', toAddress)"
            >
              <span>To</span> {{ toAddress1 }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="toAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>

          <div class="block_con">
            <div class="block_hash" @click="goDetail('hash', contractAddress)">
              <span v-if="tokenAmount!==null">
                <span v-if="tokenAmount > 999">
                  {{
                    new Intl.NumberFormat("en-US", {
                      minimumFractionDigits: 8, // 设置为足够大的值以保留所有小数位
                      maximumFractionDigits: 30,
                    }).format(tokenAmount)
                  }}
                </span>

                <span v-else>{{ tokenAmount }}</span>
              </span>
              <span v-else>
                {{
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 10,
                  }).format(tokenAmount)
                }}</span
              >
              <!-- <span class="spanblack" style="color: #fff" v-if="tokenAmount>999&&tokenAmount.length>26"> {{ Number(tokenAmount.slice(0,26)).toLocaleString() }}...</span
              >
              <span class="spanblack" style="color: #fff" v-else>{{ Number(tokenAmount).toLocaleString() }}</span> -->
              <img class="imgs" :src="logo" /><span class="spanblack">
                {{ symbol }}</span
              >
            </div>
          </div>
        </div>

        <div class="block_height borernone">
          <div class="block_tit">Reward :</div>
          <div class="block_con" style="margin-top: 4px">
            <div class="block_hash">
              {{
                new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                  maximumFractionDigits: 20,
                }).format(contractTip)
              }}
              TTOS
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- taken开始 -->
    <!-- nft开始 -->
    <div
      class="content_top"
      id="list"
      v-if="type == 8 && standard == 'ERC-721'"
    >
      <div class="head">Overview</div>
      <div class="content_center centers">
        <div class="block_height block_heighterc">
          <div class="block_tit">Transaction Type :</div>
          <div class="block_con" style="margin-top: 4px">{{ functions }}</div>
        </div>
        <div class="block_height bkheight">
          <div class="block_tit">From :</div>
          <div class="block_con" style="margin-top: 4px">
            <div
              class="block_hash blockas"
              @click="goDetail('address', fromAddress)"
            >
              {{ fromAddress }}
            </div>
            <img
              src="../../assets/m/copy@2x.png"
              v-clipboard:copy="fromAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height" style="height: 110px">
          <div class="block_tit">Interacted WIth (To) :</div>
          <div class="block_con" style="margin-top: 4px">
            <div
              class="block_hash"
              @click="goDetail('nfthash', contractAddress)"
              style="color: #fff"
            >
              Contract
            </div>
            <el-tooltip placement="right" popper-class="toolTipClass">
              <div slot="content">Smart contract account</div>
              <img src="../../assets/m/home/wdang.png" />
            </el-tooltip>
            <!-- <img src="../../assets/m/home/wdang.png" /> -->
          </div>
          <div class="block_con">
            <div
              class="block_hash blockas"
              @click="goDetail('nfthash', contractAddress)"
            >
              {{ contractAddress }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="contractAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
        </div>
        <div class="block_height" v-if="toAddress1 !== null">
          <div class="block_tit">Tokens Transferred :</div>
          <div class="block_con" style="margin-top: 4px">
            <div
              class="block_hash blockas"
              @click="goDetail('address', fromAddress)"
            >
              <span>From</span> {{ fromAddress1 }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="fromAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div class="block_con" v-if="functions !== 'balanceOf'">
            <div
              class="block_hash blockas"
              @click="goDetail('address', toAddress)"
            >
              <span>To</span> {{ toAddress1 }}
            </div>
            <img
              src="@/assets/pc/Index/fz.png"
              v-clipboard:copy="toAddress"
              v-clipboard:success="copyClicked"
              v-clipboard:error="onError"
            />
          </div>
          <div
            class="block_con"
            v-if="
              tokenAmountlist.length < 5 &&
              toAddress !== null &&
              tokenAmount !== null
            "
            style="display: flex; flex-direction: column"
          >
            <div
              class="block_hash"
              v-for="(item, index) in tokenAmountlista"
              :key="index"
            >
              <span @click="goDetail('nfthashdetail', item)">
                <img
                  v-if="nftImageLists.length > 1"
                  class="imgs"
                  :src="nftImageLists[index]"
                  style="border-radius: 4px"
                />
                <img
                  v-else
                  class="imgs"
                  :src="logo"
                  style="border-radius: 4px"
                />
                <span class="spanblack"
                  >TokenID ({{ item.split("#")[1] }})</span
                >
              </span>
              <span @click="goDetail('nfthash', contractAddress)">
                <img
                  v-if="logo1 !== ''"
                  :src="logo1"
                  style="
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    margin-top: 6px;
                  "
                />
                <span class="spanblack">{{ contractName }}</span>
              </span>
            </div>
          </div>
          <div class="block_con block_conaa" v-if="tokenAmountlist.length >= 5">
            <div
              class="block_hash"
              v-for="(item, index) in tokenAmountlista.slice(0, 5)"
              :key="index"
            >
              <span @click="goDetail('nfthashdetail', item)">
                <img
                  v-if="nftImageLists.length > 1"
                  :src="nftImageLists[index]"
                  style="
                    border-radius: 4px;
                    width: 20px;
                    height: 20px;
                    margin-top: 8px;
                    margin-bottom: 2px;
                    margin-right: 8px;
                  "
                  @click="goDetail('nfthashdetail', item)"
                />
                <img
                  v-else
                  :src="logo"
                  style="
                    border-radius: 4px;
                    width: 18px;
                    height: 18px;
                    margin-top: 8px;
                    margin-right: 2px;
                  "
                  @click="goDetail('nfthash', item)"
                />
                <span class="spanblack" style="margin-top: 6px"
                  >TokenID ({{ item.split("#")[1] }})</span
                >
              </span>
              <span @click="goDetail('nfthash', contractAddress)">
                <img
                  :src="logo1"
                  style="
                    border-radius: 50%;
                    width: 18px;
                    height: 18px;
                    margin-top: 6px;
                  "
                />
                <span class="spanblack">{{ contractName }}</span>
              </span>
            </div>
            <div
              style="color: #fff; margin-top: 10px"
              @click="dialogVisible1 = true"
              v-if="tokenAmountlist.length > 5"
            >
              More
            </div>
          </div>
        </div>
        <el-dialog
          title=""
          :visible.sync="dialogVisible1"
          :modal="true"
          :before-close="handleClose"
        >
          <div class="listbox">
            <div class="listboxtit">
              <img src="@/assets/m/home/tan.png" @click="handleClose" />
            </div>
            <div class="gundong">
              <div
                class="listall"
                v-for="(item, index) in tokenAmountlist"
                :key="index"
              >
                <div class="bocbox">
                  <span>
                    <span class="tits">From</span>
                    <span
                      class="conts"
                      @click="goDetail('address', fromAddress)"
                      >{{ fromAddress1 }}</span
                    ></span
                  ><img
                    class="img1"
                    src="@/assets/pc/Index/copy1.png"
                    v-clipboard:copy="fromAddress"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    style="
                      width: 30px;
                      height: 30px;
                      margin-right: 20px;
                      margin-top: 2px;
                    "
                  />
                  <span>
                    <span class="tits">To</span>
                    <span
                      class="conts"
                      @click="goDetail('address', toAddress)"
                      >{{ toAddress1 }}</span
                    ></span
                  ><img
                    class="img2"
                    src="@/assets/pc/Index/copy1.png"
                    v-clipboard:copy="toAddress"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    style="width: 30px; height: 30px; margin-top: 2px"
                  />
                  <img
                    v-if="nftImageLists.length > 1"
                    :src="nftImageLists[index * pageNum]"
                    class="img3"
                    style="
                      border-radius: 4px;
                      width: 30px;
                      height: 30px;
                      margin-top: 4px;
                      margin-right: 10px;
                    "
                    @click="goDetail('nfthashdetail', item)"
                  />
                  <img
                    v-else
                    :src="logo"
                    class="img3"
                    style="
                      border-radius: 4px;
                      width: 30px;
                      height: 30px;
                      margin-top: 4px;
                      margin-right: 10px;
                    "
                    @click="goDetail('nfthashdetail', item)"
                  />
                  <span @click="goDetail('nfthashdetail', item)">
                    TokenID
                    <span style="color: #fff"
                      >({{ item.split("#")[1] }})</span
                    ></span
                  >

                  <img
                    :src="logo1"
                    style="
                      border-radius: 50%;
                      width: 30px;
                      height: 30px;
                      margin-top: 4px;
                      margin-left: 18px;
                    "
                    @click="goDetail('nfthash', contractAddress)"
                  />
                  <span
                    @click="goDetail('nfthash', contractAddress)"
                    style="color: #fff; font-size: 12px"
                    >{{ contractName }}</span
                  >
                </div>
              </div>
            </div>
            <el-pagination
              :current-page.sync="pageNum"
              background
              small
              :page-size="size"
              layout="prev, pager,
    next"
              @current-change="CurrentChange1"
              :total="totalall"
            >
            </el-pagination>
          </div>
        </el-dialog>

        <div class="block_height borernone">
          <div class="block_tit">Reward :</div>
          <div class="block_con">
            <div class="block_hash">
              {{
                new Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                  maximumFractionDigits: 20,
                }).format(contractTip)
              }}
              TTOS
            </div>
          </div>
          <div v-if="functions == 'mint'">
            <div class="block_tit">Price :</div>
            <div class="block_con">
              <div class="block_hash">
                {{
                  new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                    maximumFractionDigits: 20,
                  }).format(contractTransfer)
                }}
                TTOS
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- nft结束 -->
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import {
  VerifyList,
  TransactionDetail,
  GetheightDetailBonus,
  GetheightDetailTransfer,
  ContractTransfer,
  ContractCreate,
} from "../../assets/server/api.js";
import {
  timestampConvertTimea,
  timestampConvertTime,
  formatSeconds,
  getSubStr,
  listTypea,
} from "../../utils/utils.js";

export default {
  components: {
    Seacher,
  },
  data() {
    return {
      dialogVisible1: false,
      searchValue: "",
      pageSize: 1,
      total: null,
      pageNum: 1,
      pagerCount: 0,
      amount: 0,
      fromAddress: "",
      gas: 0,
      height: 0,
      toAddress: "",
      tradeTime: "",
      timeas: "",

      // type: "",
      verifyAddressList: [],

      transferList: [],
      flag: false,
      H: "",
      addressList: [],
      addressLists: [],
      addressLists1: [],

      //开始
      TimeDatea: "",
      activeNames: ["0"],
      signList: [],
      Commission: "",
      validatorNickName: "",
      validatorLogo: "",
      amount: "",
      imgurl1: require("@/assets/pc/Index/vers.png"),
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl2: require("@/assets/pc/Index/nft.png"),
      toAwardList: [],
      toAwardListdata: [],
      type: "", //根据传过来的type进行展示
      //当类型为Transfer type=1
      fromAddress: "",
      fromAddress1: "",
      toAddress: [],
      dialogVisible: false,
      dialogVisible3: false,
      total1: "",
      txHash: "",
      standard: "",
      blHash: "",
      contractName: "",
      contractAddress: "",
      from: "",
      fromEvmAddress: "",
      toEvmAddress: "",
      fromEvmAddress1: "",
      toEvmAddress1: "",
      functions: "",
      tokenAmount: "",
      logo: "",
      logo1: "",
      typename: "",
      symbol: "",
      //当类型为Transfer type=1
      toAddressa: [],
      toAddressaa: [],
      toAddressb: "",
      tokenAmountlist: [],
      tokenAmountlista: [],
      tokenAmountlists: [],
      nftImageLists: [],
      toAddress1: "",
      contractCreator: "",
      size: 4, //一页多少条
      totalall: "",
      contractTransfer: "", //  是price值
      contractTip: "", // 是reward
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
    percentages() {
      return this.toAwardList.reduce(
        (acc, item) => acc + parseFloat(item.amount),
        0
      );
      // return this.toAwardList.map(item =()=> ((parseFloat(item.amount)*100).toFixed(2)));
      // return this.toAwardList.reduce((acc, item) => acc + item.amount, 0);
    },
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/m/TransferDetails") {
          this.txHash = to.query.txHash;
          // console.log(this.txHash);
          this.standard = to.query.standard;
          //  console.log(this.standard);
          //  console.log(this.txHash);
          this.type = to.query.type;
          //  console.log(this.type);
          // this.getTransactionDetail1();
          if (
            this.type == 99 ||
            this.type == "toAward" ||
            this.type == "commission" ||
            this.type == "fromAward"
          ) {
            this.GetDetailBonus();
          } else if (
            this.type == 1 ||
            this.type == 2 ||
            this.type == 3 ||
            this.type == 4 ||
            this.type == 5 ||
            this.type == "to" ||
            this.type == "from" ||
            this.type == -1
          ) {
            this.GetDetailTransfer();
          } else if (this.type == 8 && this.standard == "ERC-20") {
            this.GetContractTransfer();
            // this.GetContractCreate();
          } else if (this.type == 8 && this.standard == "ERC-721") {
            // this.GetContractCreate();
            this.GetContractTransfer();
          } else if (this.type == 7) {
            this.GetContractCreate();
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.txHash = this.$route.query.txHash;
  },
  mounted() {
    this.H = document.body.offsetHeight + "px";
    window.onresize = () => {
      return (() => {
        this.H = document.body.offsetHeight + "px";
      })();
    };
    // this.getTransactionDetail();
    // this.getTransactionDetail1();
  },
  destroyed() {},
  methods: {
    CurrentChange1(val) {
      // console.log(val);
      this.pageNum = val;
      this.getTabelData2();
    },
    //获取表格数据，自行分页（splice）
    getTabelData2() {
      this.tokenAmountlist = this.tokenAmountlists.slice(
        (this.pageNum - 1) * this.size,
        this.pageNum * this.size
      );
      this.tokenAmountlista = this.tokenAmountlists.slice(0, 5);
      // console.log(this.tokenAmountlist);
      // this.nftImageLists =this.nftImageLists.slice((this.PaginationIndex - 1) * this.size,
      //   this.PaginationIndex * this.size)
      // th
      // let data=this.tokenAmountlists;
      // console.log(this.tokenAmountlists);
      // this.tokenAmountlist = data.splice(
      //   (this.PaginationIndex - 1) * this.size,
      //   this.size
      // );
      // this.totalall=this.tokenAmountlist.length;
      //  console.log(this.totalall);
    },
    isImageUrl(url) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"]; // Add more extensions if needed
      const lowercasedUrl = url.toLowerCase();
      const extension = lowercasedUrl.split(".").pop();
      return imageExtensions.includes(extension);
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    onCopy(e) {
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    handleClose() {
      this.pageNum = 1;
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.dialogVisible3 = false;
      // this.GetDetailTransfer();
    },
    //开始
    handleChange(val) {
      // console.log(val);
    },
    async GetContractCreate() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractCreate(formData);
      // console.log(res);
      // contractName:"",
      // contractAddress:""
      this.contractName = res.result.contractName;
      this.contractAddress = res.result.contractAddress;
      this.height = res.result.height;
      this.blHash = res.result.blockHash;
      //  console.log(this.blHash);
      this.txHash = res.result.txHash;
      this.signList = res.result.signNodes;
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);

      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      this.tradeTime = formatSeconds(s);
      this.gas = res.result.gas;
      var offset = this.getClientTimezone;
      var korean = 3600000 * offset;
      var ass = res.result.tradeTime - korean;
      this.timeas = timestampConvertTime(ass);
      this.contractCreator = res.result.contractCreator;
      this.contractName = res.result.contractName;
      if (this.contractName == "" || this.contractName == null) {
        if (res.result.symbol == "" || res.result.symbol == null) {
          //  console.log(333);

          this.contractName = getSubStr(this.contractAddress, 0, 3);
          //  this.contractName=getSubStr(this.contractAddress,0,3);
        } else {
          this.contractName = res.result.symbol;
        }
      }
    },
    async GetDetailTransfer() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
        pageNum: this.pageNum,
        pageSize: 5,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetheightDetailTransfer(formData);
      // console.log(res);
      this.typename = listTypea(res.result.type);
      this.signList = res.result.signNodes;
      this.fromAddress = res.result.fromAddress;
      if (this.fromAddress == "Unpledge") {
        this.fromAddress = "Unstake";
      }
      // this.toAddress = res.result.toList;
      // console.log(this.toAddress);
      this.toAddressa = res.result.toList;
      if (this.pageNum == 1 && res.result.toList.length > 0) {
        this.toAddressaa = res.result.toList;
        // console.log(this.toAddressaa);
      }
      // console.log(this.toAddressa);
      if (this.toAddressa.length == 0) {
        this.toAddressb = res.result.toAddress;
        //   console.log(this.toAddressb);
      }
      //  console.log(this.toAddressa);
      this.total1 = res.result.toCount;
      //  console.log(this.total1);
      this.amount = res.result.amount;
      this.height = res.result.height;
      this.blHash = res.result.blockHash;
      this.txHash = res.result.txHash;
      // this.list[0].Balance = res.result.height;
      // this.list[1].Balance = res.result.blockHash;
      // console.log(this.list[1].Balance);
      // this.list[2].Balance = res.result.txHash;
      // console.log(this.list[2].Balance);
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);
      this.TimeDatea = timestampConvertTimea(UTCTime);
      this.TimeDatea =
        this.TimeDatea.split(",")[0] +
        "," +
        (this.TimeDatea.split(",")[1] - 1) +
        "," +
        this.TimeDatea.split(",")[2];
      // console.log(this.TimeDatea);
      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      this.tradeTime = formatSeconds(s);
      this.gas = res.result.gas;
      var offset = this.getClientTimezone;
      var korean = 3600000 * offset;
      var ass = res.result.tradeTime - korean;
      this.timeas = timestampConvertTime(ass);
      if (this.toAddressa.length == 0) {
        this.toAddressb = res.result.toAddress;
        //  console.log(this.toAddressb);
        if (this.toAddressb == "Pledge") {
          this.toAddressb = "Stake";
        }
      }
      // console.log(this.toAddressa);
      this.total1s = res.result.toCount;
      //  console.log(this.total1s);
      this.amount = res.result.amount;
      // this.list[4].Balance = formatSeconds(s);
      // this.list[5].Balance = res.result.gas;
      // this.signList = res.result.signNodes;
      // this.fromAddress = res.result.fromAddress;
      // this.toAddress = res.result.toList;
      // this.total1=this.toAddress.length;
      // this.amount = res.result.amount;
    },
    async GetDetailBonus() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetheightDetailBonus(formData);
      //  console.log(res);
      this.signList = res.result.signList;
      this.amount = res.result.amount;
      this.Commission = res.result.Commission;
      // this.validatorNickName = res.result.validatorNickName;
      if (res.result.validatorNickName == "") {
        this.validatorNickName = getSubStr(res.result.validatorAddress, 0, 6);
      } else {
        this.validatorNickName = res.result.validatorNickName;
      }
      this.address = res.result.validatorAddress;
      this.validatorLogo = res.result.validatorLogo;
      this.toAwardList = res.result.toAwardList;
      if (this.validatorLogo == "") {
        this.validatorLogo = this.imgurl1;
      }
      // for(var i=0;i<this.toAwardList.length;i++){
      //   if(parseFloat(this.toAwardList[i].amount)<parseFloat(0.01)){
      //     this.toAwardList[i].amount=0.01;
      //   }
      // }
      // for(var i=0;i<this.toAwardList.length;i++){
      //   this.this.toAwardListdata.push(this.toAwardList[i].amount);
      // }

      this.blHash = res.result.blockHash;
      this.txHash = res.result.txHash;
      this.height = res.result.height;
      // console.log(this.signList);
      // this.list[0].Balance = res.result.height;
      // this.list[1].Balance = res.result.blockHash;
      // console.log(this.list[1].Balance);
      // this.list[2].Balance = res.result.txHash;
      // console.log(this.list[2].Balance);

      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);
      this.TimeDatea = timestampConvertTimea(UTCTime);
      this.TimeDatea =
        this.TimeDatea.split(",")[0] +
        "," +
        (this.TimeDatea.split(",")[1] - 1) +
        "," +
        this.TimeDatea.split(",")[2];

      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      this.tradeTime = formatSeconds(s);
      this.gas = res.result.gas;
      var offset = this.getClientTimezone;
      var korean = 3600000 * offset;
      var ass = res.result.tradeTime - korean;
      this.timeas = timestampConvertTime(ass);
      // this.list[4].Balance = formatSeconds(s);
      // this.list[5].Balance = res.result.gas;
    },
    async GetContractTransfer() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await ContractTransfer(formData);
      //  console.log(res);
      this.height = res.result.height;
      //  console.log(this.height);
      this.blHash = res.result.blockHash;
      this.txHash = res.result.txHash;
      this.gas = res.result.gas;
      this.signList = res.result.signNodes;
      let UTCTime = res.result.tradeTime - this.getClientTimezone * 3600000;
      this.TimeDate = timestampConvertTime(UTCTime);

      var calctime = new Date();
      let strdate = Math.floor(calctime.getTime() / 1000);
      let timestamp = Math.floor(this.gltime(res.result.tradeTime) / 1000);
      var s = strdate - timestamp;
      if (s <= 0) {
        s = 1;
      }
      this.tradeTime = formatSeconds(s);
      this.gas = res.result.gas;
      var offset = this.getClientTimezone;
      var korean = 3600000 * offset;
      var ass = res.result.tradeTime - korean;
      this.timeas = timestampConvertTime(ass);
      this.contractName = res.result.contractName;
      this.contractAddress = res.result.contractAddress;
      this.from = res.result.from;
      this.functions = res.result.functions;
      this.fromAddress = res.result.fromEvmAddress;
      this.fromAddress1 = getSubStr(this.fromAddress, 0, 3);
      this.contractAddress = res.result.contractAddress;
      this.toAddress = res.result.toEvmAddress;
      this.contractTransfer = res.result.contractTransfer;
     // console.log(this.contractTransfer);
      this.contractTip = res.result.contractTip;
      //  console.log(this.toAd);
      if (
        res.result.toEvmAddress == null ||
        res.result.toEvmAddress == "" ||
        this.toAddress == ""
      ) {
        //    console.log(this.toAddress);
        this.toAddress1 = this.toAddress;
        //   console.log(this.toAddress1);
        // this.toAddress1 = getSubStr(this.toAddress, 0, 6);
      } else {
        this.toAddress = res.result.toEvmAddress;
        //   console.log(this.toAddress);
        this.toAddress1 = this.toAddress;
        this.toAddress1 = getSubStr(this.toAddress, 0, 3);
      }
      if (res.result.functions == "balanceOf") {
        this.toAddress1 = "";
      }
      if (res.result.logo == "" || res.result.logo == null) {
        if (res.result.functions == "mint") {
          this.logo = this.imgurl2;
        } else {
          this.logo = this.imgurl;
        }
        // this.logo = this.imgurl;
      } else {
        this.logo = res.result.logo;
      }

      // if(res.result.toAddress !==''){
      //   this.toAddress1 = getSubStr(res.result.toAddress, 0, 6);
      // }

      this.symbol = res.result.symbol;
      this.tokenAmount = res.result.tokenAmount;
      if (this.tokenAmount !== null) {
        this.tokenAmountlist = res.result.tokenAmount.split(",");
        this.tokenAmountlista = res.result.tokenAmount.split(",");
        this.tokenAmountlista = this.tokenAmountlista.slice(0, 5);
        this.tokenAmountlists = res.result.tokenAmount.split(",");
        this.totalall = this.tokenAmountlist.length;
        this.tokenAmount = this.tokenAmountlist[0];
      }
      // console.log(this.tokenAmountlist);
      // console.log(this.tokenAmountlist.length);
      this.contractName = res.result.contractName;
      // console.log(this.contractName);
      if (res.result.logo == "" || res.result.logo == null) {
        this.logo1 = this.imgurl;
       // console.log(444);
      } else {
        this.logo1 = res.result.logo;
        //console.log(555);
      }
      if (res.result.logo == "" || res.result.logo == null) {
        this.logo = this.imgurl2;
        //console.log(2222);
      } else {
        if (res.result.nftImageList !== null) {
          var images = JSON.parse(res.result.nftImageList);
          //    console.log(images);
          if (images.length == 1) {
            this.logo = images[0];
            // if (this.check_is_img(this.logo) == false) {
            //   this.logo = this.imgurl2;
            // }
          }
          // nftImageLists
          if (images.length > 1) {
            this.nftImageLists = JSON.parse(res.result.nftImageList);
            //  console.log(this.nftImageLists);
          }
        } else {
          this.logo = res.result.logo;
          if (this.logo == "") {
            this.logo = this.imgurl2;
          }
        }
        // this.logo = res.result.logo;
      }
      if (res.result.standard == "ERC-20" && res.result.logo == "") {
        this.logo = this.imgurl;
      }
      if (res.result.standard !== "ERC-20" && res.result.logo == "") {
        this.logo = this.imgurl2;
      }
      if (res.result.type == "8" && res.result.standard == "ERC-721") {
        var images = JSON.parse(res.result.nftImageList);
        if (res.result.nftImageList !== null) {
          var images = JSON.parse(res.result.nftImageList);
          //  console.log(images);
          if (images.length == 1) {
            this.logo = images[0];
            // if (this.check_is_img(this.logo) == false) {
            //   this.logo = this.imgurl2;
            // }
          }
          // nftImageLists
          if (images.length > 1) {
            this.nftImageLists = JSON.parse(res.result.nftImageList);
            //     console.log(this.nftImageLists);
          }
        } else {
          this.logo = this.imgurl2;
          // if (this.logo == "" || this.check_is_img(this.logo) == false) {
          //   this.logo = this.imgurl2;
          // }
        }
      }
      if (
        res.result.type == "8" &&
        res.result.standard == "ERC-20" &&
        (res.result.logo == null || res.result.logo == "")
      ) {
        //this.logo = res.result.logo;
        this.logo = this.imgurl;
      }
      //判断8 standard ERC 721 functions mint
      if (
        res.result.type == "8" &&
        res.result.standard == "ERC-721" &&
        res.result.functions == "mint"
      ) {
        if (res.result.logo == null) {
          //console.log(1111);
          this.logo1 = this.imgurl;
        }
      }
      //判断8 standard ERC 721 functions mint
      //     if((res.result.type == "8" && res.result.standard == "ERC-721")&& res.result.functions=='mint'){
      //    if(res.result.logo ==null){
      //     console.log(1111)
      //     this.logo1=this.imgurl2;
      //    }
      // }
      // if (
      //   res.result.type == "8" &&
      //   res.result.standard == "ERC-721"
      //     ) {
      //       var images = JSON.parse(res.result.nftImageList);
      //       console.log(images);
      //       this.logo = images[0];
      //     }
    },
    //结束
    stopMove() {
      document.body.style.overflow = "hidden ";
      document.body.style.position = "fixed";
      document.body.style.top = "0px";
      var body = document.body;
      body.addEventListener("touchmove", function (event) {
        event.preventDefault();
      });
    },
    Move() {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
    },
    tankuang() {
      this.flag = true;
      this.stopMove();
    },
    none() {
      this.flag = false;
      this.Move();
    },
    async getTransactionDetail1() {
      this.txHash = this.$route.query.txHash;
      let formData = new FormData();
      let params = {
        txHash: this.txHash,
        pageNum: 1,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await TransactionDetail(formData);

      this.addressLists1 = res.result.toList;
    },

    searchs(e) {
      this.txHash = e.txHash;
      //console.log(this.txHash);
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.GetDetailTransfer();
      // this.getTransactionDetail();
    },
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },

    goDetail(name, query) {
      // console.log(query);
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
        case "txnhash":
          this.$router.push({
            path: "/m/TransferDetails",
            query: { txHash: query.txHash, type: query.type1 },
            // query: { txHash: query },
          });
          break;
        case "blockHash":
          this.$router.push({
            path: "/m/BlockDetails",
            query: { blockHash: query },
          });
          break;
        case "height":
          this.$router.push({
            path: "/m/BlockHeight",
            query: { height: query },
          });
          break;
        case "hash":
          // let params = {
          //   contractAddress: query.contractAddress,
          // };
          // console.log(params);
          this.$router.push({
            path: "/m/Overaddress",
            query: { contractAddress: query },
          });
          break;
        case "nfthash":
          // let params = {
          //   contractAddress: query.contractAddress,
          // };
          // console.log(params);
          this.$router.push({
            path: "/m/NftOveraddress",
            query: { contractAddress: query },
          });
          break;
        case "nfthashdetail":
          // let params = {
          //   contractAddress: query.contractAddress,
          // };
          // console.log(params);

          this.$router.push({
            path: "/m/NFTslistdetail",
            query: {
              contractAddress: this.contractAddress,
              tokenId: query,
            },
          });
          break;
        //     let params = {
        //   contractAddress: this.transferList[Index].contractAddress,
        //   tokenId: this.transferList[Index].tokenAmount,
        // };
        // console.log(params);
        // this.$router.push({ path: "/m/NFTslistdetail", query: params });
      }
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-collapse-item__wrap {
  background: #0b0c0f !important;
  border: none !important;
}
/deep/.el-collapse-item__header {
  background: #0b0c0f !important;
  border: none !important;
  color: #fff !important;
}
/deep/ .el-collapse {
  border: none !important;
}
/deep/ .el-collapse-item__arrow {
  display: none;
}
/deep/.el-collapse-item__content {
  padding-bottom: 0px !important;
}
/deep/.el-dialog__title {
  margin-left: 80px;
  font-size: 14px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #898b8d;
}
/deep/.el-message {
  margin-top: 120px !important;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  border: none;
}
/deep/.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

/deep/.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: SF Pro Text-Regular, SF Pro Text;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
/deep/.v-modal {
  opacity: 0.8 !important;
  background: #13161b !important;
}
/deep/.el-dialog {
  background: rgba(0, 0, 0, 0.8);
  width: 682px !important;
  // height: 440px !important;
  // background: #000000;
  border-radius: 20px 20px 20px 20px;
  margin-top: 228px !important;
}
/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.el-button--text {
  color: #fff !important;
  cursor: pointer;
}
</style>

<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  overflow: hidden;
  // pointer-events: none;
  // position: fixed;
  background: #13161b;
  text-align: center;
  //普通交易开始

  .transactionsbox {
    width: 702px;
    margin: 0 auto;
    background: #0b0c0f;
    border-radius: 24px 24px 24px 24px;
    opacity: 1;
    margin-top: 24px;
    .tangkuang {
      width: 682px;
      height: 952px;
      background: #000000;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      // border: 1px solid red;

      .tit {
        // margin-top: 24px;
        margin-left: 610px;
        img {
          width: 48px;
          height: 48px;
          margin-top: 24px;
          margin-right: 24px;
        }
      }
      .tangkuang_tit {
        display: flex;
        justify-content: space-between;
        height: 50px;
        margin-top: 18px;
        div {
          margin-left: 32px;
          font-size: 32px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 38px;
        }
        div:nth-child(2) {
          font-size: 32px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #8a8a8a;
          margin-right: 121px;
        }
      }
      .tangkuang_con {
        // height: 200px;
        width: 634px;
        margin: 0 auto;
        overflow: hidden;
        // overflow-y: scroll;
        margin-top: 40px;
        .tangkuang_li {
          display: flex;
          height: 100px;
          border-bottom: 1px solid #22252e;
          // line-height: 136px;
          margin-bottom: 32px;

          img {
            width: 48px;
            height: 48px;
            margin-left: 42px;
            margin-top: 12px;
            // margin-right: 12px;
          }
          span {
            font-size: 26px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #ffffff;
            line-height: 38px;
            letter-spacing: 1px;
          }
          span:nth-child(1) {
            width: 310px;
            text-align: left;
            // overflow: hidden;
            white-space: wrap;
            letter-spacing: 0px;
            // text-overflow: ellipsis;
            // -o-text-overflow: ellipsis;
          }
          span:nth-child(3) {
            width: 200px;
            font-size: 26px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #ffffff;
            text-align: right;
            margin-top: 16px;
          }
        }
      }
    }
    .transactionstit {
      text-align: left;
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 42px;
      margin-left: 24px;
      padding-top: 24px;
    }
    .transactionscd {
      border-bottom: none !important;
    }
    .transactionsc {
      text-align: left;
      margin-left: 24px;
      margin-top: 30px;
      border-bottom: 1px solid #22252e;
      padding-bottom: 10px;
      .tit {
        // height: 36px;
        font-size: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        // line-height: 36px;
      }
      .cond {
        color: #fff !important;
        display: flex;

        word-wrap: break-word;
        word-break: break-all;
      }
      .conca {
        display: flex;
        div {
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          // line-height: 36px;
          margin-bottom: 26px;

          width: 75.3vw;

          font-size: 3.5vw;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;

          word-wrap: break-word;
        }
        img {
          width: 46px;
          height: 46px;
          // margin-left: 20px;
          margin-top: 10px;
        }
      }
      .conc1 {
        margin-top: 16px;
      }
      .conc {
        // height: 36px;
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        // line-height: 36px;
        margin-bottom: 26px;

        width: 75.3vw;

        font-size: 3.5vw;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;

        word-wrap: break-word;

        .block_toli {
          display: flex;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding-top: 10px;

          span {
            width: 400px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
          img {
            width: 46px;
            height: 46px;

            margin-right: 30px;
          }
        }
        .btns {
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          margin-top: 10px;
        }
        .block_hash {
          margin-top: 14px;
          margin-left: 12px;
          color: #fff;
        }
        // span{
        //   width: 120px;
        // }
      }
      .block_boxlist {
        display: flex;
        flex-wrap: wrap;
        // margin-top: 30px;
        .block_li {
          width: 280px;
          // height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          margin-right: 30px;
          // line-height: 34px;
          // margin-bottom: 30px;
        }
      }
    }
  }
  .content_top {
    margin: 30px auto 0px auto;
    width: 702px;
    /*height: 310px;*/
    background: #0b0c0f;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
  }

  .list {
    text-align: center;
    padding-bottom: 80px;
  }
  .list-data {
    margin: 30px auto 0px auto;
    width: 690px;
    // height: 1650px;
    /*height: 920px;*/
    background: #232a35;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    // border: 2px solid #f0f2f3;

    .block {
      margin-top: 32px;
      padding-bottom: 32px;
      font-size: 28px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #adb0c7;
      line-height: 39px;
    }
  }

  .head {
    width: 702px;
    padding: 24px 12px;
    // margin:32px 0 32px 32px;
    background: #0b0c0f;
    opacity: 1;
    border-radius: 16px 16px 16px 16px;
    padding-left: 30px;
    text-align: left;
    height: 48px;
    font-size: 30px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    line-height: 48px;
    span {
      font-size: 26px;
      font-family: "PingFang SC-中黑体, PingFang SC";
      font-weight: normal;
      color: #b2b7c2;
      line-height: 36px;
    }
  }
  .xian {
    border-bottom: none !important;
  }
  .centers {
    border-bottom: none !important;
  }
  .content_center:last-of-type {
    border-bottom: none;
  }
  .content_center {
    text-align: left;
    padding: 20px 0px 40px 0px;
    font-size: 26px;
    font-family: SF Pro Text-Medium, SF Pro Text;
    font-weight: normal;
    color: #adb0c7;
    // line-height: 36px;
    border-bottom: 1px solid #3c485c;
    margin: 0px 32px;
    // 弹框样式开始
    .listbox {
      // border: 1px solid red;
      width: 682px;
      height: 886px;
      background: #000000;
      overflow: hidden;

      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      .listbox::-webkit-scrollbar {
        display: none;
      }
      .listboxtit {
        margin-top: 24px;

        img {
          width: 48px;
          height: 48px;
          margin-left: 610px;
        }
      }
      .gundong {
        // border: 1px solid red;
        overflow: hidden;
        height: 686px;
        // overflow-y: auto;
      }
      .gundong::-webkit-scrollbar {
        display: none;
      }
      .listall {
        border-bottom: 1px solid #22252e;
        width: 602px;
        margin: 0 auto;
        margin-bottom: 30px;
        overflow-y: auto;
        height: 148px;
        // border: 1px solid yellow;
        .bocbox {
          // border: 1px solid yellow;
          // border-bottom: 1px solid #22252e;
          // height: 786px;

          width: 506px;
          // margin-left: 36px;

          span {
            font-size: 24px;
            font-family: Roboto-Medium, Roboto;
            font-weight: 500;
            color: #8a8a8a;
            margin-top: 10px;
            display: inline-block;
            .tits {
              font-size: 24px;
              font-family: Roboto-Medium, Roboto;
              font-weight: 500;
              color: #8a8a8a;
              margin-right: 20px;
            }
            .conts {
              color: #fff;
            }
            .img1 {
              width: 30px;
              height: 30px;
            }
          }
          // overflow: hidden;
        }
      }
    }
    .borernone {
      border-bottom: none !important;
    }
    .bkheight {
      height: 140px !important;
    }
    .bkheightb {
      height: 280px !important;
    }
    .bkheighta {
      height: 340px !important;
    }
    .block_heighterc {
      height: 100px;
    }
    .block_height1 {
      margin-top: 6px !important;
      height: 100px !important;
    }
    .block_height {
      // height: 100px;
      margin-top: 28px;
      border-bottom: 1px solid #22252e;
      .block_tit {
        font-size: 26px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #8a8a8a;
        height: 36px;
        line-height: 36px;
      }
      .blocka {
        color: #fff !important;
      }
      .block_conaa {
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
      }
      .block_con {
        font-size: 26px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #8a8a8a;
        // height: 36px;
        line-height: 36px;
        // margin-top: 12px;
        display: flex;
        justify-content: space-between;
        .block_hash {
          // width: 465px;
          // height: 72px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #8a8a8a;
          line-height: 36px;
          word-wrap: break-word;
        }
        .imgs {
          // width: 50px;
          height: 50px;
          // border: 1px solid red;

          margin-bottom: 10px;
          margin-right: 10px;
        }
        .spanblack {
          display: inline-block;
          padding-top: 8px;
          font-size: 26px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        img {
          // width: 50px;
          height: 50px;
          margin-left: 10px;
          border-radius: 50%;
        }
      }
      .blockas {
        color: #fff !important;
        span {
          color: #8a8a8a !important;
        }
      }
      .block_boxlist {
        display: flex;
        flex-wrap: wrap;
        .block_li {
          width: 280px;
          // height: 34px;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          margin-right: 30px;
        }
      }
    }
  }
  .To_List {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    overflow: hidden;
    overscroll-behavior: contain;
    .To_List-all {
      position: absolute;
      top: 15%;
      margin-left: 72px;
      background: #232a35;
      padding: 30px 20px;
      border-radius: 16px;
      .To_List_top {
        height: 42px;
        width: 566px;
        display: flex;
        justify-content: space-between;
        opacity: 1;
        span:nth-child(1) {
          margin-top: 20px;
          margin-left: 10px;
          font-size: 28px;
          font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          line-height: 22px;
        }
        span:nth-child(2) {
          float: right;
          cursor: pointer;
          margin-top: 18px;
          margin-right: 10px;
          display: block;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
      .To_List_ul {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        margin-bottom: 30px;
        margin-left: 10px;
        ul {
          height: 610px;
          overflow: hidden;
          li {
            height: 62px;
            width: 566px;
            p {
              width: 100%;
              line-height: 62px;
              width: 566px;
              display: flex;
              justify-content: space-between;
              span:nth-child(1) {
                width: 220px;
                display: inline-block;
                font-size: 28px;
                font-family: SF Pro Text-Regular, SF Pro Text;
                font-weight: 400;
                color: #00a870;
                line-height: 62px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              span:nth-child(2) {
                margin-left: 20px;
                float: right;
                line-height: 62px;
                img {
                  width: 48px;
                  height: 48px;
                  cursor: pointer;
                  line-height: 124px;
                }
              }
              span:nth-child(3) {
                color: #fff;
                margin-left: 20px;
              }
            }
          }
        }
        ::-webkit-scrollbar {
          width: 0px;
          height: 1px;
        }
        ::-webkit-scrollbar-thumb {
          opacity: 0;
        }
      }
    }
  }
}
</style>
